import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('lastNameField');

    return {
        LAST_NAME_FIELD_LABEL: t('lastNameFieldLabel')
    };
};

export default useTranslation;
